const USER_LOGIN_TYPE = {
  0: 'TEL_VERIFY_CODE', // 手机号+验证码
  1: 'TEL_OPENID' // 手机号+openid
}
const USER_INFO_H5 = {

}
// 获取jssdk request
const OTHER_GET_JSSDK = {

}
// 根据deviceCode获取修改信息
const EQUIPMENT_INFO = {

}
// 根据mediaId下载资源上传到七牛，返回七牛url
const UPLOAD_MEDIA_H5 = {

}
// 获取七牛token request
const OTHER_GET_QINIU_TOKEN_H5 = {

}
const ROLE_DEL_WEB = {

}
const REPAIR_H5 = {

}
const USER_EDIT_H5 = {

}
/*
  报修详细
 */
const REPAIR_INFO_H5 = {

}
/*
  取消报修
 */
const REPAIR_EDIT_CANCEL_H5 = {

}
/*
  取消报修
 */
const USER_EDIT_PHONENUM_H5 = {

}
/*
  获取评价列表
 */
const APPRAISAL_LIST_H5 = {

}
/*
  已完成待评价数量
 */
const REPAIR_COUNT_H5 = {

}
/*
  用户报修搜索
 */
const REPAIR_SEARCH_H5 = {

}
/*
  保存设备
 */
const USER_DEVICE_EDIT_H5 = {

}
/*
* 删除设备
* */
const USER_DEVICE_DEL_H5 = {

}
/*
  省市管理
 */
const PROVINCE_CITY_SEARCH_H5 = {

}
/*
  提交问卷
 */
const APPRAISAL_RECORD_SUBMIT_H5 = {

}
/*
  提交问卷记录
 */
const APPRAISAL_RECORD_LIST_H5 = {

}
const REPAIR_STATUS = {
  TRANSMITTED: '已受理',
  TRANSMITTED_ERROR: '已受理',
  ALREADY_SUBMIT: '已提交',
  ALREADY_ALLOT: '已派员',
  ALREADY_DISPOSE: '已到达',
  COMPLETE: '已完成',
  WAITING_COMMENT: '已完成(待评价)',
  ALREADY_COMMENT: '已评价',
  ALREADY_CANCEL: '已取消',
  CLOSED: '已关闭',
  ACCEPTED: '已受理',
  '': '全部'
}
const REPAIR_STATUS_reverse = {
  '全部': '',
  '已提交': 'ALREADY_SUBMIT',
  // eslint-disable-next-line no-dupe-keys
  '已受理': 'ACCEPTED',
  // eslint-disable-next-line no-dupe-keys
  '已受理': 'TRANSMITTED_ERROR',
  // eslint-disable-next-line no-dupe-keys
  '已受理': 'TRANSMITTED',
  '已派员': 'ALREADY_ALLOT',
  '已到达': 'ALREADY_DISPOSE',
  '已完成(待评价)': 'WAITING_COMMENT',
  '已评价': 'ALREADY_COMMENT',
  '已完成': 'COMPLETE',
  '已取消': 'ALREADY_CANCEL',
  '已关闭': 'CLOSED'
}
const RECORD_STATUS = [
  '全部',
  '已提交',
  '已受理',
  '已派员',
  '已到达',
  '已完成',
  '已完成(待评价)',
  '已评价',
  '已取消',
  '已关闭'
]
const NUMBER = [
  '10', '9', '8', '7', '6', '5', '4', '3', '2', '1'
]
const BASE_SEND_VERIFY_H5 = {

}
const USER_REGISTER_H5 = {

}
export {
  USER_EDIT_PHONENUM_H5,
  ROLE_DEL_WEB,
  USER_DEVICE_DEL_H5,
  EQUIPMENT_INFO,
  OTHER_GET_JSSDK,
  UPLOAD_MEDIA_H5,
  OTHER_GET_QINIU_TOKEN_H5,
  APPRAISAL_RECORD_LIST_H5,
  APPRAISAL_RECORD_SUBMIT_H5,
  APPRAISAL_LIST_H5,
  PROVINCE_CITY_SEARCH_H5,
  REPAIR_EDIT_CANCEL_H5,
  USER_DEVICE_EDIT_H5,
  REPAIR_COUNT_H5,
  USER_REGISTER_H5,
  BASE_SEND_VERIFY_H5,
  NUMBER,
  RECORD_STATUS,
  REPAIR_STATUS_reverse,
  REPAIR_STATUS,
  REPAIR_SEARCH_H5,
  USER_LOGIN_TYPE,
  USER_INFO_H5,
  REPAIR_H5,
  USER_EDIT_H5,
  REPAIR_INFO_H5
}
